export const DEFAULT_CURRENCY = "RUB";
export const TIMEOUT_ANIMATION_BUTTON = 500;
export const BUTTON_UPDATE_TITLE = "Актуализировать цену в USD";